var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocumFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 376,
    viewBox: "0 0 376 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3853_32191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.91 306.81H333.691C344.011 306.81 352.377 298.444 352.377 288.124L352.377 19.1372C352.377 8.81735 344.011 0.451508 333.691 0.451508H202.91C192.59 0.451508 184.224 8.81735 184.224 19.1372L184.224 288.124C184.224 298.444 192.59 306.81 202.91 306.81Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.635 297.087H329.97C337.791 297.087 344.131 290.747 344.131 282.926L344.131 23.4947C344.131 15.6738 337.791 9.33371 329.97 9.33371H206.635C198.814 9.33371 192.474 15.6738 192.474 23.4947L192.474 282.926C192.474 290.747 198.814 297.087 206.635 297.087Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.06 17.9993H250.64",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.067 92.8594H374.797V306.81H305.211",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.301 232.428H245.415V334.987H365.301V232.428Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.502 282.967V260.466H297.218V282.967H286.268L305.478 299.783L324.565 282.863L313.502 282.967Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.368 280.177V306.95H269.348V280.177",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.259 185.529C308.855 185.529 310.96 183.424 310.96 180.828C310.96 178.232 308.855 176.127 306.259 176.127C303.663 176.127 301.558 178.232 301.558 180.828C301.558 183.424 303.663 185.529 306.259 185.529Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.044 180.828H225.646",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.259 202.187C308.855 202.187 310.96 200.083 310.96 197.486C310.96 194.89 308.855 192.786 306.259 192.786C303.663 192.786 301.558 194.89 301.558 197.486C301.558 200.083 303.663 202.187 306.259 202.187Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.044 197.486H225.646",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.334 218.735C309.86 218.139 311.425 215.607 310.829 213.08C310.232 210.554 307.701 208.989 305.174 209.585C302.647 210.182 301.082 212.713 301.679 215.24C302.275 217.767 304.807 219.332 307.334 218.735Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.044 214.145H225.646",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.63 83.7874C149.923 79.9897 149.865 76.1605 149.422 72.3764C148.921 68.0595 147.923 63.8193 146.975 59.5836C145.999 55.217 145.056 50.8188 144.771 46.3393C144.487 41.8914 145.209 37.5835 145.67 33.1808C146.085 29.2025 146.085 25.1159 144.405 21.3995C143.443 19.2681 136.426 10.851 133.952 8.90026C125.914 2.56032 115.289 -0.135505 105.16 0.555386C95.1127 1.24176 85.4899 5.31034 78.0978 12.1651C74.5576 15.4479 71.5457 19.2862 69.202 23.5083C68.0099 25.6623 66.9939 27.9156 66.1766 30.2366C65.287 32.7653 64.6774 35.3754 64.1491 37.9989C63.2324 42.5326 62.5099 47.3734 60.4688 51.591C58.9832 52.7966 57.3079 53.7811 55.4294 54.5171C51.7853 55.9531 47.8883 56.5717 44.0771 57.3665C28.3311 60.6629 12.8787 68.8046 4.90858 83.3449C1.08836 90.3034 -0.848846 98.4677 0.356826 106.375C1.43154 113.414 4.89954 120.134 10.2009 124.916C12.3955 126.898 14.8881 128.51 17.5975 129.671C18.8619 131.987 20.4423 134.141 22.2531 136.069C28.0602 142.247 36.0754 145.814 44.1765 147.882C59.6289 151.829 76.4045 151.775 91.8524 147.878C107.007 144.057 121.141 136.277 131.631 124.591C141.709 113.365 148.456 98.9012 149.625 83.7874H149.63Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.969 54.1965L77.321 98.0342C77.321 98.0342 102.13 128.61 120.825 127.404C139.519 126.198 136.038 105.038 122.107 98.4677L112.123 96.9369L124.83 62.7446L98.969 54.1965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.364 99.7953L124.826 62.7446L98.9691 54.1965L80.175 92.2497",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.845 97.0452L120.269 98.1831",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.297 46.2309C104.297 46.2309 100.445 38.6492 93.4553 40.0671C84.6814 41.8462 89.346 59.1094 100.567 57.8812C100.567 57.8812 107.187 80.2606 124.306 76.7836C135.789 74.4535 140.91 51.758 132.985 32.4673C132.985 32.4673 126.93 33.9845 121.077 31.23C121.077 31.23 120.355 40.4644 104.297 46.2264V46.2309Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4553 47.7708C95.9254 48.1997 98.2058 49.6176 99.6824 51.6452",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6175 375.248H197.766L159.302 222.133C162.287 222.011 165.168 220.954 167.493 219.003C169.056 217.689 170.853 216.131 172.736 214.388C178.566 209.001 180.029 201.465 180.846 193.571C181.569 186.595 179.469 179.654 177.202 173.016C170.79 154.249 162.788 135.965 152.366 119.09C148.957 113.568 145.213 108.122 140.156 104.053C135.098 99.9894 128.51 97.429 122.102 98.4631C122.134 98.4992 122.166 98.5353 122.197 98.5715L116.557 97.0452V90.8136H111.938L109.432 104.88L105.512 90.8136L80.1703 85.3091L73.4059 94.1145C70.2765 93.7894 67.0388 94.0604 63.914 94.53C51.049 96.4672 38.0485 101.949 30.4442 112.507C23.4179 122.26 21.9232 134.904 21.8871 146.925C21.8103 171.165 26.8046 195.486 37.0957 217.432C41.4759 226.77 47.2559 236.117 56.4 240.886C57.9489 241.694 59.6152 242.317 61.3356 242.755C27.0936 300.131 39.8186 375.479 38.6085 375.244L38.6175 375.248Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.646 134.335H78.45V146.13H106.646V134.335Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2017 144.098C70.5748 154.683 73.948 165.272 77.3212 175.857",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.319 137.681C145.358 146.094 147.539 154.818 148.808 163.673",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7394 231.692C81.0916 232.853 81.6019 234.162 82.7534 234.541C83.6656 234.84 84.7674 234.636 85.5079 234.027C101.439 221.026 114.142 212.654 133.008 204.54C135.406 203.51 131.617 213.982 145.263 204.63C147.417 203.153 145.615 198.751 143.042 198.322C145.173 198.024 146.988 196.181 147.259 194.05C147.53 191.918 146.234 189.679 144.247 188.857C146.311 189.241 148.23 187.186 148.329 185.091C148.429 182.996 147.191 181.054 145.692 179.582C151.4 182.354 159.397 190.428 163.922 184.982C165.132 179.469 161.276 176.534 156.999 172.849C152.718 169.164 147.142 167.34 141.597 166.297C129.26 163.976 116.408 165.132 104.352 168.622C93.7399 171.698 83.6385 176.529 74.2685 182.35C71.9656 183.781 71.1979 184.088 71.1618 186.748C71.1257 189.597 71.9565 192.731 72.4036 195.54C73.3293 201.392 74.4492 207.213 75.7632 212.988C77.1947 219.279 78.8519 225.519 80.7394 231.692Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.351 204.327C135.171 203.745 136.986 203.167 138.806 202.584",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6362 196.078C57.0776 191.612 63.0743 187.823 69.4459 184.829",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.248 209.701C150.334 213.3 151.364 217.157 154.204 219.369C157.857 222.214 163.095 221.406 167.543 220.128C188.667 214.054 207.719 202.336 218.674 183.28C219.125 182.495 223.144 172.858 221.5 170.686C219.952 168.641 216.109 172.524 213.598 173.052C202.72 175.337 191.986 178.304 181.478 181.926C176.078 183.791 170.736 185.823 165.466 188.031C161.438 189.72 158.011 190.171 155.315 193.824C151.964 198.372 150.113 204.043 150.248 209.697V209.701Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.548 220.128C188.672 214.054 207.723 202.336 218.678 183.28C219.13 182.494 223.149 172.858 221.505 170.686",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.758 152.258H193.923C193.097 152.258 192.311 152.637 191.801 153.287L160.494 193.12C159.103 194.89 160.363 197.486 162.617 197.486H200.11C200.918 197.486 201.686 197.125 202.196 196.497L234.849 156.665C236.294 154.904 235.038 152.258 232.762 152.258H232.758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.249 157.383C215.784 156.954 215.115 156.534 214.56 156.837C214.072 157.099 213.986 157.744 213.955 158.295C213.648 163.687 213.336 169.083 213.029 174.475C213.092 169.652 211.842 164.662 208.717 160.987C207.949 160.083 206.59 159.23 205.682 159.993C205.136 160.454 205.091 161.271 205.122 161.985C205.389 168.04 207.814 174.294 205.687 179.97C205.307 176.362 204.449 172.809 203.144 169.422C202.607 168.035 201.943 166.613 200.733 165.751C199.523 164.888 197.617 164.838 196.71 166.017C195.748 167.268 196.344 169.052 196.872 170.537C198.403 174.845 199.053 179.469 198.769 184.03C198.182 180.462 197.45 176.62 194.786 174.172C194.005 173.454 193.043 172.876 191.991 172.79C190.934 172.705 189.792 173.201 189.336 174.159C188.834 175.211 189.25 176.444 189.584 177.559C190.88 181.858 190.853 186.531 189.593 190.839C188.649 194.068 184.603 198.412 188.884 200.936C190.352 201.803 192.167 201.867 193.851 201.627C198.62 200.945 202.761 198.064 206.486 195.016C210.293 191.901 213.905 188.482 216.678 184.423C219.455 180.363 221.365 175.613 221.505 170.695C221.645 165.778 219.879 160.716 216.253 157.392L216.249 157.383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.508 234.031C85.508 234.031 77.4701 243.636 61.3403 242.76",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9758 306.177C79.3215 304.687 80.6762 303.116 81.2497 301.192C81.8231 299.268 81.3942 296.902 79.7279 295.782C78.5493 294.988 76.9734 294.938 75.8445 294.08C74.3046 292.91 74.1059 290.576 74.8284 288.779C75.5509 286.986 76.9779 285.586 78.3009 284.177C81.8954 280.348 85.0383 275.927 86.4652 270.87C87.8876 265.812 87.3954 260.032 84.2661 255.81C81.1413 251.588 75.1265 249.42 70.3128 251.52C66.759 253.074 64.429 256.478 62.2931 259.716C56.9104 267.88 51.5052 276.081 47.4186 284.967C43.332 293.854 40.591 303.518 40.8393 313.294C40.9296 316.852 41.4444 320.487 43.1513 323.612C44.8582 326.732 47.9379 329.27 51.4827 329.582C57.213 330.088 59.4121 324.073 63.0517 320.88C68.3079 316.274 73.2931 311.361 77.9758 306.173V306.177Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2447 310.856C10.6207 303.784 10.2279 293.371 16.3195 287.519C18.8121 285.126 22.5194 282.877 22.0995 279.45C21.9369 278.108 21.1196 276.948 20.2345 275.927C17.0645 272.283 12.8063 269.768 9.32024 266.431C5.83418 263.089 3.02546 258.321 4.09566 253.611C5.01685 249.556 8.74676 246.522 12.8108 245.628C16.8704 244.733 21.1557 245.695 24.9262 247.452C36.2469 252.722 43.2913 264.711 45.6665 276.97C48.0417 289.23 46.4251 301.879 44.5331 314.22C44.1086 316.992 43.63 319.864 42.0405 322.172C35.5921 331.56 19.1869 316.884 15.2493 310.86L15.2447 310.856Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1638 260.439C24.2669 261.364 28.7961 268.933 29.4192 276.067C30.0424 283.202 27.8839 290.251 27.0576 297.363C26.2312 304.475 27.0937 312.513 32.395 317.331",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.574 291.601C37.3577 287.514 40.0309 283.568 40.0219 279.106C40.0129 272.649 34.5535 267.754 30.7017 262.57C23.7973 253.281 21.5666 240.295 26.3486 229.755C31.1261 219.211 43.3635 212.162 54.6706 214.637C58.7708 215.535 62.8078 217.775 64.745 221.496C66.9757 225.777 66.0003 230.988 64.5598 235.598C63.1193 240.204 61.2318 244.9 61.7963 249.692C62.7987 258.194 71.112 264.25 72.855 272.635C74.6613 281.342 68.9671 289.732 63.0516 296.374C59.7191 300.113 56.1969 303.771 53.4695 307.993C50.3446 312.834 49.9744 317.159 48.8816 322.605C47.7165 328.408 43.8196 329.076 40.0174 324.913C36.4185 320.971 34.3684 315.358 33.4788 310.174C32.4131 303.951 33.0453 297.404 35.5785 291.601H35.574Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6554 227.624C41.2818 234.88 40.6225 245.32 45.0388 253.196C47.9514 258.393 52.8328 262.498 54.6706 268.165C56.6575 274.288 54.6616 281.007 51.7355 286.738C48.8094 292.468 44.935 297.751 42.7991 303.825C40.6632 309.898 40.609 317.272 44.8311 322.131",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4688 320.781H11.2258L16.0801 375.248H77.6146L82.4688 320.781Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.328 47.7708V127.616H285.83",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.174 72.7693H266.914V164.17H321.174V72.7693Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.331 87.7251H272.762V143.439H315.331V87.7251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.843 63.2278H262.245V74.264H325.843V63.2278Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.914 65.061V72.4305",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.667 65.061V72.4305",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.416 65.061V72.4305",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.17 65.061V72.4305",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.672 65.061V72.4305",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.918 65.061V72.4305",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.42 65.061V72.4305",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.174 65.061V72.4305",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.463 58.1477H216.596V120.034H228.463V58.1477Z",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.352 72.7693H233.485V120.039H245.352V72.7693Z",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.245 85.3137H250.378V120.039H262.245V85.3137Z",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3853_32191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375.248,
    height: 375.7,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocumFrame);
export default __webpack_public_path__ + "static/media/LocumFrame.d2e1dc70aa8ff134b61180140cb42812.svg";
export { ForwardRef as ReactComponent };